export const UPDATE_SEARCHED_MESSAGE_ID = 'UPDATE_SEARCHED_MESSAGE_ID';
export const REMOVE_SEARCHED_MESSAGE_ID = 'REMOVE_SEARCHED_MESSAGE_ID';
